import React from "react";

const Saving = props => (
    <div>
        Saving...
    </div>
);

export default Saving;
